import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';
import { CapabilitiesService } from 'src/app/shared/services/capabilities/capabilities.service';
import { CapabilityParams } from '../capabilities-params.model';

@UntilDestroy()
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[allowLinkIfHasCapability]',
    standalone: false
})
export class AllowLinkIfHasCapabilityDirective implements OnInit {
  @Input('allowLinkIfHasCapability') capabilities: CapabilityParams[];

  constructor(
    private el: ElementRef,
    private capabilitiesService: CapabilitiesService
  ) { }

  ngOnInit(): void {
    this.capabilitiesService.userHasAnyCapability(this.capabilities).pipe(
      tap(hasCapability => {
        if (hasCapability) {
          this.el.nativeElement.style.color = '#111111';
          this.el.nativeElement.style.fontWeight = 400;
          this.el.nativeElement.style.cursor = 'pointer';
          this.el.nativeElement.style.pointerEvents = 'auto';
        } else {
          this.el.nativeElement.style.color = '#555759';
          this.el.nativeElement.style.fontWeight = 400;
          this.el.nativeElement.style.cursor = 'default';
          this.el.nativeElement.style.pointerEvents = 'none';
        }
      }),
      untilDestroyed(this)
    ).subscribe();
  }
}
